import { css } from 'styled-components';
import { shades } from 'utils';
const { teals } = shades;

const pagination = css`
  .pagination{
      li{
          display: inline-block;

        &.active{
            a{
                color: #fff;
                background-color: ${teals.tilicho};
                font-weight: 600;
            }
        }

        &.disabled{
            opacity: 0.5;
            cursor: not-allowed;
        }
        
        a{
            color: ${teals.tilicho};
            padding: 6px 10px;
            border-radius: 3px;
            cursor: pointer;

            &:focus{
                outline: 0;
            }
        }

      }

      @media screen and (max-width: 768px){
          margin-bottom: 18px;
      }
  }
`;

export default pagination;



// WEBPACK FOOTER //
// ./src/components/styled/global/pagination.js